import { createIcons, icons } from 'lucide';

const loadIcons = () => {
  createIcons({ icons });
};

document.addEventListener('turbo:load', loadIcons);
document.addEventListener('turbo:render', loadIcons);
